import { render, staticRenderFns } from "./FlashNewsPicturePane.vue?vue&type=template&id=f83ab53c&"
import script from "./FlashNewsPicturePane.vue?vue&type=script&lang=ts&"
export * from "./FlashNewsPicturePane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f83ab53c')) {
      api.createRecord('f83ab53c', component.options)
    } else {
      api.reload('f83ab53c', component.options)
    }
    module.hot.accept("./FlashNewsPicturePane.vue?vue&type=template&id=f83ab53c&", function () {
      api.rerender('f83ab53c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/flashNews/FlashNewsPicturePane.vue"
export default component.exports